<template>
  <section class="home-products g-section">
    <div class="g-container">
      <div class="section-head">
        <h2>产品服务</h2>
        <p>覆盖投标、履约、预付款、质量等多场景保函需求</p>
      </div>

      <div class="categories">
        <button
          v-for="t in tabList"
          :key="t.code"
          :class="['cat', code === t.code && 'is-active']"
          @click="changeTab(t.code)"
        >
          <i class="dot"></i>
          {{ t.name }}
        </button>
      </div>

      <div v-if="productList.length" class="grid">
        <article
          v-for="item in productList"
          :key="item.id"
          class="prod-card"
          @click="checkDetail(item.id)"
        >
          <div class="prod-head">
            <div class="badge">电子保函</div>
            <div class="prod-name">{{ item.name }}</div>
          </div>
          <p class="prod-desc">{{ item.introduce }}</p>
          <ul class="prod-meta">
            <li><span>额度</span><strong>1-300 万</strong></li>
            <li><span>费率</span><strong>面议</strong></li>
            <li><span>出函时效</span><strong>最快 3min</strong></li>
          </ul>
          <div class="prod-foot">
            <span class="learn">查看详情 →</span>
          </div>
        </article>
      </div>

      <div v-else class="g-empty">
        <img src="@/assets/noData.png" />
        <p>该产品未对外开放，敬请期待</p>
      </div>
    </div>
  </section>
</template>

<script>
import { getProList, getProListByToken, getProduct, getProductByToken } from '@/lib/api/product'

export default {
  name: 'HomeProducts',
  data () {
    return { tabList: [], code: '', productList: [] }
  },
  created () {
    if (localStorage.getItem('token')) {
      getProListByToken(0).then((res) => {
        if (res.code === 200) {
          this.tabList = res.data
          this.code = res.data[0].code
          this.fetch()
        }
      })
    } else {
      getProList(0).then((res) => {
        if (res.code === 200) {
          this.tabList = res.data
          this.code = res.data[0].code
          this.fetch()
        }
      })
    }
  },
  methods: {
    fetch () {
      const fn = localStorage.getItem('token') ? getProductByToken : getProduct
      fn({ pageNum: 1, pageSize: 6, code: this.code }).then((res) => {
        if (res.code === 200) this.productList = res.rows
      })
    },
    changeTab (code) {
      this.code = code
      this.fetch()
    },
    checkDetail (id) {
      this.$router.push({ path: '/product_detail', query: { id, code: this.code } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.section-head {
  text-align: center;
  margin-bottom: 40px;

  h2 {
    margin: 0 0 8px;
    font-size: 32px;
    font-weight: 700;
    color: @text-strong;
  }
  p {
    margin: 0;
    color: @text-muted;
    font-size: 14px;
  }
}

.categories {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.cat {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 18px;
  border: 1px solid @border-base;
  border-radius: @radius-full;
  background: #fff;
  color: @text-secondary;
  font-size: 14px;
  cursor: pointer;
  transition: all @duration-fast @ease-out;

  .dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: @border-strong;
  }

  &:hover {
    color: @primary;
    border-color: @primary-soft;
    .dot { background: @primary; }
  }

  &.is-active {
    color: #fff;
    background: @primary;
    border-color: @primary;
    .dot { background: #fff; }
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.prod-card {
  background: #fff;
  border-radius: @radius-lg;
  padding: 28px;
  cursor: pointer;
  box-shadow: @shadow-sm;
  border: 1px solid transparent;
  transition: all @duration-base @ease-out;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: @shadow-lg;
    border-color: @primary-soft;
  }

  .prod-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .badge {
      display: inline-block;
      padding: 4px 10px;
      background: @primary-soft;
      color: @primary;
      font-size: 12px;
      font-weight: 600;
      border-radius: @radius-full;
    }
    .prod-name {
      font-size: 17px;
      font-weight: 700;
      color: @text-strong;
    }
  }

  .prod-desc {
    color: @text-secondary;
    font-size: 14px;
    line-height: 1.7;
    margin: 0 0 20px;
    .multi-ellipsis(2);
  }

  .prod-meta {
    list-style: none;
    margin: 0 0 20px;
    padding: 16px;
    background: @bg-soft;
    border-radius: @radius-md;

    li {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      padding: 4px 0;

      span { color: @text-muted; }
      strong { color: @text-strong; font-weight: 600; }
    }
  }

  .prod-foot {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;

    .learn {
      color: @primary;
      font-size: 13px;
      font-weight: 600;
      transition: transform @duration-fast @ease-out;
    }
  }

  &:hover .learn { transform: translateX(4px); }
}
</style>
